import React from 'react'
import { useDevice } from 'device'
import { formatPrice } from 'helpers'
import { useCandleSubscription } from 'modules/subscription'

import { BackgroundImage, Image, Text } from 'components/dataDisplay'
import { WidthContainerCompensator } from 'components/layout'
import CandleClubSubscribeButton from 'compositions/buttons/CandleClubSubscribeButton/CandleClubSubscribeButton'

import messages from './messages'
import bgDesktopImage from './images/bg-desktop.jpg'
import bgMobileImage from './images/bg-mobile.jpg?src-loader&size'


type CandleSubscriptionBannerProps = {
  className?: string
  placement: string
  withMobileCompensator?: boolean
  'data-testid'?: string
}

const CandleSubscribeSmallBanner: React.FC<CandleSubscriptionBannerProps> = (props) => {
  const { className, placement, withMobileCompensator, 'data-testid': dataTestId } = props

  const { isMobile } = useDevice()

  const { candleSubscription } = useCandleSubscription()

  const price = candleSubscription?.price || 2500
  const priceWithCents = formatPrice(price)
  const priceWithoutCents = formatPrice(price, { removeZeroCents: true })

  const content = (
    <div className={isMobile ? 'pt-40 px-40 pb-48 bg-black' : 'w-6/12 pb-4 text-left'}>
      <Text
        message={messages.supTitle}
        style="eye2"
        color="gold-30"
      />
      <Text
        className="mt-16"
        message={messages.title}
        style={isMobile ? 'h5' : 'h7'}
        color="white"
      />
      <Text
        className="mt-16"
        message={{ ...messages.text, values: { price: priceWithoutCents } }}
        style={isMobile ? 'p1' : 'p3'}
        color="white"
      />
      <CandleClubSubscribeButton
        className="mt-16"
        title={{ ...messages.buttonTitle, values: { price: priceWithCents } }}
        placement={placement}
        size={isMobile ? 56 : 48}
        style="gold-30"
        width={240}
        fullWidth
        data-testid="candleSubscriptionBanner"
      />
    </div>
  )

  const Wrapper = isMobile && withMobileCompensator ? WidthContainerCompensator : React.Fragment

  return (
    <Wrapper>
      <div className={className} data-testid={dataTestId}>
        {
          isMobile ? (
            <>
              <Image className="w-full" {...bgMobileImage} />
              {content}
            </>
          ) : (
            <BackgroundImage
              className="px-32 bg-black flex flex-col justify-center items-start"
              src={bgDesktopImage}
              style={{ backgroundPosition: '0 50%', height: '296rem' }}
            >
              {content}
            </BackgroundImage>
          )
        }
      </div>
    </Wrapper>
  )
}


export default CandleSubscribeSmallBanner
